import PropTypes from 'prop-types';
// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// contexts
import SettingsProvider from './contexts/Settings';
import EventProvider from './contexts/Event';
import AuthProvider from './contexts/Auth';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';

// ----------------------------------------------------------------------

App.propTypes = {
  settings: PropTypes.object
};

export default function App({ settings }) {
  return (
    <SettingsProvider settings={settings}>
      <EventProvider>
        <ThemeConfig>
          <AuthProvider>
            <ScrollToTop />
            <GlobalStyles />
            <BaseOptionChartStyle />
            <Router />
          </AuthProvider>
        </ThemeConfig>
      </EventProvider>
    </SettingsProvider>
  );
}
